import { useEffect, useRef, useState } from 'react';
import shouldReduceMotion from '../util/shouldReduceMotion';

const useRevealOnScroll = ({ rootMargin = '0px 0px -8% 0px', threshold = 0.01 } = {}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(() => shouldReduceMotion());

  useEffect(() => {
    const node = ref.current;

    if (!node || isVisible || typeof window === 'undefined') {
      return undefined;
    }

    if (shouldReduceMotion() || typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin, threshold }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [isVisible, rootMargin, threshold]);

  return { ref, isVisible };
};

export default useRevealOnScroll;
